import React from 'react'
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { RootState } from '../../presentation/redux/store/RootState';

export const ModalHelp = () => {

    const uiState = useSelector((s: RootState) => s.uiState);
    const dispatch = useDispatch();

    function handleHide() {
        dispatch(UIActions.closeModalHelp());
    }

    return (
        <Modal
            onHide={handleHide}
            show={uiState.isModalHelpOpen}
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton className='gradientBlue colorWhite'>
                <Modal.Title id="contained-modal-title-vcenter">
                    Ayuda
                </Modal.Title>
            </Modal.Header>
            <Modal.Body
                className='p-0'>

                <video width="100%" height="100%" controls>
                    <source src="https://movivendor.s3.amazonaws.com/AyudaMovivendor.mp4" type="video/mp4" />
                </video>

            </Modal.Body>
            <Modal.Footer>

                <button onClick={handleHide} className="btn btn-primary float-right">Cerrar</button>
            </Modal.Footer>
        </Modal>

    )
}
